const parse = require('url-parse');
export const getQS = () => {

    //para extraer los parametros de la url
    const { bd, px, pxq, ui, ag, idrt, opc } = parse(location.href, true).query;

    let path = null;
    let Idt = null;
    let opcVal = null;
    if (pxq) {
        path = [pxq]
        if (idrt){
            Idt = idrt;
            opcVal = opc;
        }
    }
    else if (bd && px) {
        path = [bd, px]
        if (idrt){
            Idt = idrt;
            opcVal = opc;
        }
    }
    Idt = (idrt && opcVal) ? idrt + opcVal : null;
    
    return [path, ui, ag, Idt]
}